import { BasketLimitAlert } from "./basket-limit-alert"

export function BasketLimit({ itemType, itemCount, itemLimit, children }) {
    const allowAddItem = itemCount < itemLimit
    return !allowAddItem ? <BasketLimitAlert itemType={itemType} /> : children
}
